import { useMemo } from 'react';

import { IMyResult } from 'modules/mavzuli-test';

export function useTestResults(myResults?: IMyResult) {
  return useMemo(() => {
    let correctAnswersCount = 0;
    let totalQuestions = 0;
    let incorrectAnswers = 0;

    myResults?.result?.forEach(result => {
      result.questions?.forEach(({ checked, correct }) => {
        totalQuestions += 1;
        if (checked === correct) {
          correctAnswersCount += 1;
        } else if (checked !== 0) {
          incorrectAnswers += 1;
        }
      });
    });

    return { correctAnswersCount, totalQuestions, incorrectAnswers };
  }, [myResults]);
}
